import { createV3Queries } from "@query/utils/createV3Queries";
import { insuranceMonitorConfigurationsApi } from "@api";

/**
 * Insurance-monitor-configuration registry — mirrors
 * `InsuranceMonitorConfigurationsApi` 1:1
 * (`/v3/compliance/insurance-monitor-configurations`; create and read only).
 *
 * A configuration holds the coverage requirements — accepted policy types,
 * limit floors and accepted evidence sources — that an `InsuranceCoverage`
 * requirement definition points at through its `dataSourceId`, and that every
 * monitor validates against. One configuration backs many monitors.
 */
export const queriesInsuranceMonitorConfigurations = createV3Queries(
  "insuranceMonitorConfigurationsApi",
  insuranceMonitorConfigurationsApi
);
